(ns web3.routing.auxiliary
  (:require [web3.utils :as utils]
            [clojure.string :as str]
            [clojure.string :as string]
            [web3.routing.utils :as routing-u]
            [cljs.tools.reader :as edn]))

(defn wrap-parens
  [s]
  (str "(" s ")"))

(defn try-read-string [s]
  (try (edn/read-string s)
       (catch js/Error e
         s)))

(defn parse-path
  "Given a `path` string, returns map of {<router>, <path>}

  :root will contain the base route.
  :query will contain a map of query parameters.

  Using the Angular auxiliary route format of http://<root-route>(aux1:<aux1-route>//aux2:<aux2-route>)"
  [path]
  (let [[_ root-string auxiliary-string query-string] (re-find #"([^(?]*)(?:\(([^(]+)\))?(\?.*)?" path)]
    (merge {:router/root (utils/ensure-prefix "/" root-string)
            :query {:path query-string
                    :data (->> (routing-u/query query-string)
                               (utils/map-vals try-read-string))}}
           (->> (when auxiliary-string
                  (string/split auxiliary-string "//"))
                (reduce (fn [m path]
                          (let [[_ router path] (re-find #"([^:]+)(?::?(.*))" path)]
                            (assoc m (keyword "router" router) (utils/trim-leading-char \/ path)))) {})))))

(defn emit-aux-string
  "Given a map of auxiliary routing data of the form {<router-key>, {:path <path>}},
   emits a list of //-joined auxiliary routes, wrapped in parentheses.

   (nav:details/edit//drawer:profile/photo)"
  [aux-routers]
  (some->> aux-routers
           (keep (fn [[router {:keys [path]}]]
                   (when path
                     (str (name router)
                          (some->> path
                                   (utils/trim-leading-char \/)
                                   (utils/some-str)
                                   (str ":"))))))
           (seq)
           (str/join "//")
           (wrap-parens)))

(defn emit-path
  "Emits full path for the provided `routes`, which should be a map
   of the form {<router-key>, {:path <path>}}, with the following special cases:

  `:query` should be the map of query parameters,
  `:root` should be the primary path,
  other keys will be handled as auxiliary routers."
  [{:keys [router/root query] :as routers}]
  (str (:path root "/")
       (some-> routers
               (dissoc :router/root :query)
               (emit-aux-string))
       (:path query)))

(comment
  (assert (= (emit-path {:router/root {:path "/x"}
                         :nav {:path "/y"}
                         :query {:a 1}})
             "/x(nav:y)?a=1")
          "Join root and aux paths.
           Query-string is appended to end of path.")

  (assert (= (parse-path "/x")
             {:router/root "/x"
              :query {}})
          "Parse root route")

  (assert (= (parse-path "/x?a=1")
             {:router/root "/x"
              :query {:a 1}})
          "Parse query string")

  (assert (= (parse-path "/x(nav:y)?a=1")
             {:router/root "/x"
              :nav "y"
              :query {:a 1}})
          "Parse aux route")

  (assert (= (parse-path "")
             (parse-path "/") {:router/root "/"
                               :query {}}))

  (assert (= (parse-path "a")
             (parse-path "/a") {:router/root "/a"
                                :query {}}))
  (assert (= {:router/root "/"
              :nav "a"
              :query {}}
             (parse-path "(nav:a)")
             (parse-path "(nav:/a)")
             (parse-path "/(nav:a)"))))
